<script setup>
const props = defineProps({
  isRange: {
    type: Boolean,
    default: false,
  },
  selectedFilters: {
    type: Array,
    default: [],
  },
  filter: {
    type: Object,
    default: {},
  },
});

const isListOpen = ref(false);

const emit = defineEmits(["get-selected-attributes"]);

const minValue = ref(props.filter.minValue ?? 0);
const maxValue = ref(props.filter.maxValue ?? 0);

const filterVal = computed(() => {
  let data = [];
  for (let elem of props.selectedFilters) {
    if (elem.filterId === props.filter.id) {
      if (elem.isRange) {
        elem.values.forEach((val) => {
          data.push(parseFloat(val));
        });
      } else {
        elem.values.forEach((val) => {
          data.push(`${elem.filterId}-${val}`);
        });
      }
    }
  }
  return data;
});

const valuesFilter = computed({
  get() {
    return filterVal.value;
  },
  async set(value) {
    if (props.isRange) {
      if (props.selectedFilters) {
        emit("get-selected-attributes", {
          filterId: props.filter.id,
          isRange: props.isRange,
          values: value,
        });
      }
    } else {
      const data = new Map();

      value.forEach((f) => {
        let arr = [f.split("-", 1).toString(), f.split("-").slice(1).join("-")];
        const [attrId, value] = arr.map((elem) => String(elem));
        if (!data.has(attrId)) {
          data.set(attrId, []);
        }
        data.get(attrId).push(value);
      });

      let element = data.entries().next().value;
      let filterId = element ? element[0] : props.filter.id;
      let values = element ? element[1] : [];
      emit("get-selected-attributes", {
        filterId: filterId,
        isRange: props.isRange,
        values: values,
      });
    }
  },
});
</script>
<template>
  <div v-if="filter.allValues.length">
    <div
      class="flex justify-between items-center"
      :class="isListOpen ? 'pb-3' : 'pb-0'"
      @click=""
    >
      <p class="font-base font-lato">{{ filter.name }}</p>
      <p-icon-down-arrow
        class="cursor-pointer"
        style="flex-shrink: 0;"
        :isOpen="isListOpen"
        @click="isListOpen = !isListOpen"
      ></p-icon-down-arrow>
    </div>
    <div
      :class="isListOpen ? 'ui-collapse__content_in' : 'ui-collapse__content'"
    >
      <template v-if="isRange">
        <p-product-filter-range-item
          class="mb-3"
          :min="minValue"
          :max="maxValue"
          :step="filter.step"
          v-model="valuesFilter"
        ></p-product-filter-range-item>
      </template>
      <template v-else>
        <p-product-filter-checkbox-item
          v-model="valuesFilter"
          :filterId="filter.id"
          :attributes="filter.allValues"
        >
        </p-product-filter-checkbox-item>
      </template>
    </div>
  </div>
</template>

<style scoped>
.ui-checkbox__input {
  height: 0;
  margin: 0 !important;
  opacity: 0;
  position: absolute;
  top: 50%;
}

.ui-collapse__content_in {
  -o-animation-duration: 0.5s;
  -moz-animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -o-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -o-animation-name: ui-collapse-in;
  -moz-animation-name: ui-collapse-in;
  -webkit-animation-name: ui-collapse-in;
  animation-name: ui-collapse-in;
  opacity: 1;
  overflow: visible !important;
  transition: opacity 0.5s ease-in;
}

.ui-collapse__content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>
